"use client";
import { Separator } from "components/ui/separator";
import DotPattern from "components/magicui/dot-pattern";
import { cn } from "lib/utils";
import SparklesText from "components/magicui/sparkles-text";
import { ShineBorder } from "components/magicui/shine-border";
import { Switch } from "components/ui/switch";
import { Label } from "components/ui/label";
import { useState } from "react";
import { Card } from "components/ui/card";

const PricingCard = () => {
  "use client";
  const [isBilledAnnually, setIsBilledAnnually] = useState(true);

  return (
    <Card className="relative flex h-[500px] w-3/4 sm:w-1/2 xl:w-1/4 flex-col items-center justify-center overflow-hidden rounded-lg border bg-background md:shadow-xl p-2">
      <ShineBorder shineColor={["#A07CFE", "#FE8FB5", "#FFBE7B"]} />
      <div className="grow flex items-center justify-center">
        <div>
          <SparklesText
            text={`${Intl.NumberFormat("fr-FR", {
              style: "currency",
              currency: "EUR",
            }).format(isBilledAnnually ? 72.42 : 79)} TTC`}
            sparklesCount={2}
            className="!text-foreground text-4xl"
          />
          <p className="text-xs text-right w-full text-muted-foreground">
            {isBilledAnnually
              ? "facturé annuellement"
              : "facturé mensuellement"}
          </p>
        </div>
      </div>
      <Separator />
      <div className="h-8 pt-2">
        <div className="space-x-2 flex items-center">
          <Switch
            id="is-deferred"
            checked={isBilledAnnually}
            onCheckedChange={(newIsBilledAnnually) => {
              setIsBilledAnnually(newIsBilledAnnually);
            }}
          />
          <Label htmlFor="is-deferred">{"Facturé annuellement"}</Label>
        </div>
      </div>
      <DotPattern
        width={20}
        height={20}
        cx={1}
        cy={1}
        cr={1}
        className={cn(
          "[mask-image:linear-gradient(to_bottom_right,white,transparent,transparent)] "
        )}
      />
    </Card>
  );
};

export default PricingCard;
